var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: ', ';\n'], ['\n  color: ', ';\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: ', ';\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { values } from 'ramda';
import Theme from '../../Theme';

export var size = {
  sm: 14,
  md: 16,
  lg: 18
};

export var weight = {
  light: 300,
  normal: 500,
  bold: 600
};

var Paragraph = styled.p(_templateObject, function (props) {
  return props.color || Theme.colors.primary;
}, Theme.fonts.Montserrat, function (props) {
  return (size[props.size] || size.md) + 'px';
}, function (props) {
  return weight[props.fw] || weight.light;
});

Paragraph.displayName = 'Paragraph';

Paragraph.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  fw: PropTypes.oneOf(['light', 'normal', 'bold']),
  color: PropTypes.oneOf(values(Theme.colors))
};

export default Paragraph;